import React, { Component } from "react";
import { Link } from "react-router-dom";
import ProfileIcon from "../ProfileIcon";
import formatPublishedDate from "../../../utils/formatPublishedDate";

import styles from "./StoryHeader.css";

class StoryHeader extends Component {
  render() {
    const story = this.props.story;
    if (!story) return null;
    return (
      <div className={styles.root}>
        <div className={styles.profile}>
          {story.byline_photo ? (
            <img
              src={story.byline_photo}
              role="presentation"
              alt=""
              className={styles.bylinePhoto}
            />
          ) : (
            <ProfileIcon className={styles.icon} />
          )}
          <div>
            {story.authors &&
              story.authors.map((author, index) => (
                <Link
                  key={author.username}
                  to={`/authors/${author.username}`}
                  className={styles.author}
                >
                  {author.display_name}
                  {index < story.authors.length - 1 && ", "}
                </Link>
              ))}{" "}
            <span className={styles.date}>{formatPublishedDate(story)}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default StoryHeader;
